import { renderFieldData } from "@Components/FieldData/RenderFieldData";
import Grid from "@Components/Grid";
import Paper from "@Components/Paper";
import { Dealership } from "@Types/dealerships";
import { formatPhoneNumber } from "@Utils/functions";

type Props = {
  dealer: Dealership;
};

const DealerInfo = ({ dealer }: Props) => {
  return (
    <Paper style={{ padding: 2, width: "100%" }}>
      <Grid container xs={12} spacing={1}>
        <Grid xs={8}>
          {renderFieldData(
            "Address",
            `${dealer?.data.info.address ?? ""} ${
              dealer?.data.info.county ?? ""
            } 
          ${dealer?.data.info.city ?? ""}
                    ${dealer?.data.info.state ?? ""}`
          )}
        </Grid>
        <Grid xs={4}>
          {renderFieldData(
            "Phone",
            `${formatPhoneNumber(dealer?.data.info.phone ?? "")}`
          )}
        </Grid>
      </Grid>
    </Paper>
  );
};

export default DealerInfo;
